
// Libraries
var React = require('react');
var Modal = require('tg-modal').default;

// Assets
var close = require('images/close.svg');

// Styles
require('tg-modal/dist/default.scss');
require('./GenericModal.scss');

class GenericModal extends React.Component {

	constructor(props) {
		super(props);
	}

	render() {

		return (
			<div className={`c-generic-modal ${
				this.props.isPremium ? " c-generic-modal--premium" : ""
			  }`}>
				<Modal isOpen={this.props.isOpen} onCancel={this.props.onCancel} keyboard={true}>
					<button className="c-generic-modal__close" onClick={this.props.onCancel} type="button">
						Close <span className="u-visually-hidden">{this.props.closeAccessibilityText ||  'popup'}</span>
						<svg width={30} height={30} className="c-generic-modal__close-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 196.2 196.2"  xmlSpace="preserve">
							<path d="m112.9 98.1 72.4-72.4c2-2 3.1-4.6 3.1-7.4 0-2.8-1.1-5.4-3.1-7.4s-4.6-3.1-7.4-3.1c-2.8 0-5.4 1.1-7.4 3.1L98.1 83.3 25.7 10.9c-2-2-4.6-3.1-7.4-3.1-2.8 0-5.4 1.1-7.4 3.1s-3.1 4.6-3.1 7.4c0 2.8 1.1 5.4 3.1 7.4l72.4 72.4-72.4 72.4c-4.1 4.1-4.1 10.7 0 14.8 2 2 4.6 3.1 7.4 3.1 2.8 0 5.4-1.1 7.4-3.1l72.4-72.4 72.4 72.4c2 2 4.6 3.1 7.4 3.1s5.4-1.1 7.4-3.1c4.1-4.1 4.1-10.7 0-14.8l-72.4-72.4z" fill="currentColor"/>
						</svg>
					</button>
					{this.props.children}
				</Modal>
			</div>
		)
	}
}

module.exports = GenericModal;



// WEBPACK FOOTER //
// ./src/components/GenericModal/GenericModal.js